import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "kinsokuset"
    }}>{`KinsokuSet`}</h1>
    <p>{`Predefined kinsoku set options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NOTHING`}</strong>{` = 1851876449`}</p>
      <p parentName="blockquote">{`Does not use a kinsoku set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HARD_KINSOKU`}</strong>{` = 1248357235`}</p>
      <p parentName="blockquote">{`Uses the hard or maximum kinsoku set, which includes all Japanese characters that should not begin or end a line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SOFT_KINSOKU`}</strong>{` = 1249078131`}</p>
      <p parentName="blockquote">{`Uses the soft or weak kinsoku set, which omits from the hard kinsoku set long vowel symbols and small hiragana and katakana characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KOREAN_KINSOKU`}</strong>{` = 1263692659`}</p>
      <p parentName="blockquote">{`Uses the Korean kinsoku set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SIMPLIFIED_CHINESE_KINSOKU`}</strong>{` = 1396927347`}</p>
      <p parentName="blockquote">{`Uses the simplified Chinese kinsoku set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRADITIONAL_CHINESE_KINSOKU`}</strong>{` = 1413704563`}</p>
      <p parentName="blockquote">{`Uses the traditional Chinese kinsoku set.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      